module.exports = __webpack_public_path__ + "img/bg-top-414.1cf826fc.png";